import { render, staticRenderFns } from "./ImageCardRedesigned.vue?vue&type=template&id=08d6c249&scoped=true&"
import script from "./ImageCardRedesigned.vue?vue&type=script&lang=js&"
export * from "./ImageCardRedesigned.vue?vue&type=script&lang=js&"
import style0 from "./ImageCardRedesigned.vue?vue&type=style&index=0&id=08d6c249&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d6c249",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardTitle,VContainer,VFlex,VHover,VLayout})
